import React, {useState, useEffect,useRef} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic  } from 'antd';
import {getMarsLiquidityInfo,getMarsxLiquidityInfo} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
import './tan.css'
import '../invite/index.less'
import { getLpInfo} from "../../api";
import { CSSTransition } from 'react-transition-group';

const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Pool = (props) => {
    const ref = useRef()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)

    const [airBonus,setAirBonus] = useState("")
    const [lpLocal_n,setLpLocalN] = useState("")
    const [lpLocalDayBonus,setLpLocalDayBonus] = useState("")

    const [marsLpTotal,setMarsLpTotal] = useState("")
    const [marsMarsTotal,setMarsMarsTotal] = useState("")
    const [marsUsdtTotal,setMarsUsdtTotal] = useState("")
    const [marsLpMy,setMarsLpMy] = useState("")
    const [marsMarsMy,setMarsMarsMy] = useState("")
    const [marsUsdtMy,setMarsUsdtMy] = useState("")
    const [marsLpPerMy,setMarsLpPerMy] = useState("")

    const [marslpBonusBnbEdMy,setMarsLpBonusBnbEdMy] = useState("")
    const [marslpBonusBnbEdTotal,setMarsLpBonusBnbEdTotal] = useState("")
    const [marslpBonusBnbWait,setMarslpBonusBnbWait] = useState("")

    const [marsxLpMy,setMarsxLpMy] = useState("")
     const [marsxlpBonusBnbEdMy,setMarsxLpBonusBnbEdMy] = useState("")
    const [marsxlpBonusBnbEdTotal,setMarsxLpBonusBnbEdTotal] = useState("")
    const [marsxlpBonusBnbWait,setMarsxlpBonusBnbWait] = useState("")



    const [tabIndex, setTabIndex] =useState(0)


    const _getLpInfo = () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getLpInfo().then(res=>{
            setAirBonus(res.data.air_bonus)
            setLpLocalN(res.data.lp)
            setLpLocalDayBonus(res.data.day_bonus)
        })
    }



    const _getMarsPoolInfo = () =>{
        //return false
         if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getMarsLiquidityInfo(props.address).then(
            res=>{
                setMarsLpTotal(res.totalLp)
                setMarsMarsTotal(res.poolToken)
                setMarsUsdtTotal(res.poolUsdt)
                setMarsLpMy(res.myLp)
                setMarsLpBonusBnbEdTotal(res.lpBonusBnbEdTotal)
                setMarsLpBonusBnbEdMy(res.lpBonusBnbEdMy)
                setMarslpBonusBnbWait(res.marsBalanceBnb)
                //     setPoolBnb(res.poolBnb)
                // setPoolToken(res.poolToken)
                
                if(res.totalLp > 0 && res.myLp >0){
                    let per =  (res.myLp /  res.totalLp) *100
                    setMarsLpPerMy(per)
                    let _usdt = res.poolUsdt * res.myLp /  res.totalLp 
                    let _token = res.poolToken * res.myLp /  res.totalLp
                    setMarsMarsMy(_token)
                    setMarsUsdtMy(_usdt)
                }
                
            },err=>{
                message.error(err)
            }
        )
    }

    const _getMarsxPoolInfo = () =>{
        //return false
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getMarsxLiquidityInfo(props.address).then(
            res=>{
               
                setMarsxLpMy(res.myLp)
                setMarsxLpBonusBnbEdTotal(res.lpBonusBnbEdTotal)
                setMarsxLpBonusBnbEdMy(res.lpBonusBnbEdMy)
                setMarsxlpBonusBnbWait(res.marsBalanceBnb)
        
                
            },err=>{
                message.error(err)
            }
        )
    }


    const goAdd = (e) =>{
        if(e.length==0){
            return
        }
         window.open('https://pancakeswap.finance/v2/add/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/0xaeD5cb15A762Ef6A458ED9EEd85cE87527668295?chain=bsc&persistChain=1', '_blank');
    }

 

    useEffect(() => {
            window.scrollTo(0, 0)
            _getLpInfo()
             _getMarsPoolInfo()
             _getMarsxPoolInfo()
            

            const timer = setInterval(() =>{
                //  _getLpInfo()
                // _getMarsPoolInfo()
                // _getMarsxPoolInfo()
            },60000)
            ref.current = timer
            return ()=>{
                clearInterval(ref.current)
            }

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
           

            <Head/>
            
            <div style={{"backgroundColor":"#18120A"}} className='  w-full lg:w-1/3   pt-20 text-white flex flex-col items-center'>

                <div className=' w-full h-5 px-4 mt-5 flex flex-row justify-center items-center'>
                    {
                        tabIndex==0?(
                            <div  className="w-1/3 h-5 flex flex-row justify-center items-center text-sm text-text-act ">MARS {t('pool.流动池')}</div>
                        ):(
                            <div onClick={()=>setTabIndex(0)} className="w-1/3 h-5 flex flex-row justify-center items-center text-xs text-gray-50">MARS {t('pool.流动池')}</div>
                        )
                    }
                    {
                        tabIndex==1?(
                            <div className="w-1/3 h-5 flex flex-row justify-center items-center text-sm text-text-act ">MARS {t('pool.交易池')}</div>
                        ):(
                            <div onClick={()=>setTabIndex(1)} className="w-1/3 h-5 flex flex-row justify-center items-center text-xs text-gray-50">MARS {t('pool.交易池')}</div>
                        )
                    }
                    {
                        tabIndex==2?(
                            <div className="w-1/3 h-5 flex flex-row justify-center items-center text-sm text-text-act ">MARS-X {t('pool.交易池')}</div>
                        ):(
                            <div onClick={()=>setTabIndex(2)} className="w-1/3 h-5 flex flex-row justify-center items-center text-xs text-gray-50">MARS-X {t('pool.交易池')}</div>
                        )
                    }
                    
                </div>
                <div className=' w-full h-5 px-4 flex flex-row justify-center items-center'>
                    <div className="w-1/3 h-5 flex flex-row justify-center items-center ">
                    {
                        tabIndex==0?(
                             <img alt='rr' className=' ' src={require('../../assets/bg/pool/tabIndex.png')} style={{"height":"40px"}}></img>
                        ):null
                    }
                       
                    </div>
                    <div className="w-1/3 h-5 flex flex-row justify-center items-center ">
                    {
                        tabIndex==1?(
                             <img alt='rr' className=' ' src={require('../../assets/bg/pool/tabIndex.png')} style={{"height":"40px"}}></img>
                        ):null
                    }
                    </div>
                    <div className="w-1/3 h-5 flex flex-row justify-center items-center">
                    {
                        tabIndex==2?(
                             <img alt='rr' className=' ' src={require('../../assets/bg/pool/tabIndex.png')} style={{"height":"40px"}}></img>
                        ):null
                    }
                    </div>
                </div>
                <div className=' w-full h-6 mx-auto mt-8  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('pool.全网数据')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>
                {/*  */}
              <CSSTransition in={tabIndex==0} unmountOnExit={true} classNames='pool' timeout={0} appear>
                <>
                <div style={{"height":"488px"}} className=' w-full mt-7 poolbg relative flex flex-col justify-center items-center'>
                    <img alt='rr' className=' absolute top-7  animate-pulse' src={require('../../assets/bg/pool/ball1.png')} style={{"width":"200px"}}></img>
                    <div className=' w-full h-16 px-4 flex flex-row justify-between items-center'>
                        <div className='w-[100px] h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsLpTotal} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.全网数据')}</span>
                        </div>
                        <div className='w-[100px] h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsMarsTotal} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>MARS {t('pool.供应')}</span>
                        </div>
                        <div className='w-[100px] h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsUsdtTotal} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>BNB {t('pool.供应')}</span>
                        </div>
                        
                    </div>
                    <div className=' w-full h-6 mx-auto mt-80  pt-1 flex flex-row justify-center items-center  '>
                        <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                        <span className=' text-sm text-text-act'>{t('pool.我的数据')}</span>
                        <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    </div>
                    <div className=' w-full h-16 px-4 mt-7 flex flex-row justify-between items-center'>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsLpMy} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>LP {t('pool.持有')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsMarsMy} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>MARS {t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsUsdtMy} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>BNB {t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsLpPerMy} duration="1" decimals={2} />%</span>
                                <span className=' text-xs text-gray-400'>LP {t('pool.占比')}</span>
                        </div>
                    </div>
                </div>
                
                <div className=' w-full h-6 mx-auto mt-8 mb-6  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>LP {t('pool.分红池')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>
                <div className='w-full px-4'>
                    <div className="w-full  mt-4 h-72 px-5 pt-7 flex flex-col justify-start items-center shareBg2">
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.预计日分红')}</span>
                            <span className=' text-sm text-white'><CountUp start={0} end={lpLocalDayBonus} duration="1" decimals={2} /> MARS</span>
                        </div>
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.已分红数量')}</span>
                            <span className=' text-sm text-white'><CountUp start={0} end={airBonus} duration="1" decimals={2} /> MARS</span>
                        </div>
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.我的状态')}</span>
                            <span className=' text-sm text-white'>{lpLocal_n>0?t('pool.已参与'):t('pool.未参与')}</span>
                        </div>
                        
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    </div>
                </div>
                <div className='w-full flex flex-row justify-center items-center mt-6'>
                    <button onClick={goAdd}  className='w-32 h-12 shareBg4 text-sm text-white font-extrabold '>{t('pool.添加流动性')}</button>
                
                </div>
                </>
        </CSSTransition>
        <CSSTransition in={tabIndex==1} unmountOnExit={true} classNames='pool' timeout={0} appear>
                <>
                <div style={{"height":"488px"}} className=' w-full mt-7 poolbg relative flex flex-col justify-center items-center'>
                    <img alt='rr' className=' absolute top-7  animate-pulse' src={require('../../assets/bg/pool/ball2.png')} style={{"width":"200px"}}></img>
                    <div className=' w-full h-16 px-4 flex flex-row justify-between items-center'>
                        <div className=' w-40 h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marslpBonusBnbWait} duration="1" decimals={4} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.待分红量')} BNB</span>
                        </div>
                        <div className='w-40 h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marslpBonusBnbEdTotal} duration="1" decimals={4} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.已分红')} BNB</span>
                        </div>
                      
                        
                    </div>
                    <div className=' w-full h-6 mx-auto mt-80  pt-1 flex flex-row justify-center items-center  '>
                        <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                        <span className=' text-sm text-text-act'>{t('pool.我的数据')}</span>
                        <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    </div>
                    <div className=' w-full h-16 px-4 mt-7 flex flex-row justify-between items-center'>
                        {/* <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.LP持有')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>MARS{t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>USDT{t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.全网占比')}</span>
                        </div> */}
                    </div>
                </div>
                
            
                <div className='w-full px-4 -mt-16 z-30'>
                    <div className="w-full  mt-4 h-72 px-5 pt-7 flex flex-col justify-start items-center shareBg2">
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.已分红')}</span>
                            <span className=' text-sm text-white'><CountUp start={0} end={marslpBonusBnbEdMy} duration="1" decimals={6} /> BNB</span>
                        </div>
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                       
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.我的状态')}</span>
                            <span className=' text-sm text-white'>{marsLpMy>0?t('pool.已参与'):t('pool.未参与')}</span>
                        </div>
                        
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    </div>
                </div>
                <div className='w-full flex flex-row justify-center items-center mt-6'>
                    <button  onClick={goAdd}  className='w-32 h-12 shareBg4 text-sm text-white font-extrabold '>{t('pool.添加流动性')}</button>
                
                </div>
                </>
                </CSSTransition>
                <CSSTransition in={tabIndex==2} unmountOnExit={true} classNames='pool' timeout={0} appear>
                <>
                <div style={{"height":"488px"}} className=' w-full mt-7 poolbg relative flex flex-col justify-center items-center'>
                    <img alt='rr' className=' absolute top-7  animate-pulse' src={require('../../assets/bg/pool/ball3.png')} style={{"width":"200px"}}></img>
                    <div className=' w-full h-16 px-4 flex flex-row justify-between items-center'>
                        <div className=' w-40 h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsxlpBonusBnbWait} duration="1" decimals={4} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.待分红量')} BNB</span>
                        </div>
                        <div className='w-40 h-16 poolbtTop flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={marsxlpBonusBnbEdTotal} duration="1" decimals={4} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.已分红')} BNB</span>
                        </div>
                      
                        
                    </div>
                    <div className=' w-full h-6 mx-auto mt-80  pt-1 flex flex-row justify-center items-center  '>
                        <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                        <span className=' text-sm text-text-act'>{t('pool.我的数据')}</span>
                        <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    </div>
                    <div className=' w-full h-16 px-4 mt-7 flex flex-row justify-between items-center'>
                        {/* <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.LP持有')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>MARS{t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>USDT{t('pool.量')}</span>
                        </div>
                        <div className='w-[77px] h-16 poolbtBottom flex flex-col items-center justify-center'>
                                <span className=' mb-1 text-xs text-gray-50'><CountUp start={0} end={222} duration="1" decimals={2} /></span>
                                <span className=' text-xs text-gray-400'>{t('pool.全网占比')}</span>
                        </div> */}
                    </div>
                </div>
                
            
                <div className='w-full px-4 -mt-16 z-30'>
                    <div className="w-full  mt-4 h-72 px-5 pt-7 flex flex-col justify-start items-center shareBg2">
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.已分红')}</span>
                            <span className=' text-sm text-white'><CountUp start={0} end={marsxlpBonusBnbEdMy} duration="1" decimals={6} /> BNB</span>
                        </div>
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                       
                        <div className='w-full flex flex-row justify-between items-center'>
                            <span className=' text-xs text-gray-400'>{t('pool.我的状态')}</span>
                            <span className=' text-sm text-white'>{marsxLpMy>0?t('pool.已参与'):t('pool.未参与')}</span>
                        </div>
                        
                        <div className='w-full h-px my-3' style={{"backgroundColor":"#261A0E"}}></div>
                    </div>
                </div>
                <div className='w-full flex flex-row justify-center items-center mt-6'>
                    <button    className='w-32 h-12 shareBg4 text-sm text-white font-extrabold '>{t('pool.添加流动性')}</button>
                
                </div>
                </>
                </CSSTransition>
               {/*  */}
                
              

              {/* <div className=' w-full h-8 invite_bg mt-8 flex flex-row items-center justify-center'>
                    <span onClick={()=>_getTixianRecord("tixian")}>{t('mint.提取记录')}</span>
                </div> */}
            </div>
           
                <div className=' w-full h-40 ' style={{"backgroundColor":"#18120A"}}></div>
                <Foot/>
        </>
    );
}

export default connect(mapStateToProps)(Pool);
